import { TFunction } from 'i18next';
import { ThunderLightning16 } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { ImpactLevel } from 'shared/types/goal';

export type Options = {
  t: TFunction;
};

export const noImpactValue = 'none';

export const createGoalImpactFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.GoalImpact,
  label: t('context-menus.filtering.task.filters.goal-impact.title'),
  placeholder: t('general.labels.select'),
  icon: ThunderLightning16,
  type: FilterOptionType.MultiSelect,
  selectOptions: [
    {
      label: t('goal.impact.options.high.label'),
      value: ImpactLevel.High,
    },
    {
      label: t('goal.impact.options.medium.label'),
      value: ImpactLevel.Medium,
    },
    {
      label: t('goal.impact.options.low.label'),
      value: ImpactLevel.Low,
    },
    {
      label: t('context-menus.filtering.task.filters.goal-impact.options.none'),
      value: noImpactValue,
    },
  ],
  canReset: true,
});
